// extracted by mini-css-extract-plugin
export default {"root":"classes_root__f22W3","point":"classes_point__Gqkvd"};